import { Model } from 'app/model/backendmodel';
import { AdapterRegistry } from 'shell-models-lib';
import { Metamodel } from 'app/model/base/model';
import { InformixTableDataset } from 'app/model/dataset/informix-table.dataset';
import { tabularTypeDatasetAdapts, TabularTypeDatasetAdapter } from './tabular-type.dataset.adapter';

@AdapterRegistry.adapter({
    model: Metamodel.modelFor(InformixTableDataset),
    asynchronous: true,
    adapts: tabularTypeDatasetAdapts
})
export class InformixTableDatasetAdapter extends TabularTypeDatasetAdapter<InformixTableDataset, Model.DatasetResource> {
    protected async _toResource(dataset: InformixTableDataset): Promise<Model.DatasetResource> {
        return await this._toResourceInternal(dataset, Metamodel.modelFor(InformixTableDataset).name);
    }

    protected async _toModel(modelDatasetResource: Model.DatasetResource, dataset?: InformixTableDataset): Promise<InformixTableDataset> {
        return await this._toModelInternal(modelDatasetResource, dataset, InformixTableDataset.MODEL);
    }
}
